<template>
  <v-expansion-panels flat v-model="panelIndex">
    <v-expansion-panel>
      <v-expansion-panel-header hide-actions>
        <v-row no-gutters class="align-center">
          <v-col cols="1">
            <v-btn icon>
              <v-icon v-if="panelIndex === 0">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="11">{{ $t("statistics.lblFeedbackDiscussion") }}</v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row no-gutters class="align-center">
          <v-col cols="12">
            <v-rating
              v-model="feedbackRating"
              background-color="orange lighten-3"
              color="orange"
              size="20"
              style="margin-left: -8px"
            ></v-rating>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="feedbackComment"
              :rows="2"
              filled
              name="feedbackComment"
              :label="$t('statistics.lblComment')"
              dense
              :max="maxLength"
              :maxlength="maxLength"
              :counter="maxLength"
            ></v-textarea
          ></v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" sm="12" class="text-right pt-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  class="ml-2"
                  x-small
                  color="primaryDark"
                  v-bind="attrs"
                  v-on="on"
                  @click="onSaveTopic"
                  :disabled="!isDirty"
                >
                  {{ $t("btnSave") }}
                </a-btn>
              </template>
              <span>{{ $t("btnSave") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  class="ml-2"
                  x-small
                  color="secondary"
                  @click="resetFeedback"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $t("btnDiscard") }}
                </a-btn>
              </template>
              <span>{{ $t("btnDiscard") }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
  </v-expansion-panels>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { createUUID } from "../../utils/util";
import MessageSheet from "../MessageSheet.vue";
import { TITLE_LENGTH_1000 } from "@/utils/constant";
export default {
  components: { MessageSheet },
  name: "TopicFeedback",
  props: {
    selectedMeeting: {
      type: Object,
      default: null,
    },
    topic: Object,
  },
  data() {
    return {
      panelIndex: null,
      message: "",
      messageType: "",
      displayMessage: false,
      maxLength: TITLE_LENGTH_1000,
      initialFeedbackSnapshot: {
        comment: "",
        rating: 0,
      },
    };
  },
  mounted() {
    if (this.selectedMeeting.meeting_feedbacks.length) {
      const existingFeedback = this.meetingFeedbacks.find(
        (f) =>
          f.user_id === this.$auth.user.user_id && f.topic_id === this.topic.Id
      );
      if (existingFeedback) {
        this.initialFeedbackSnapshot.comment = existingFeedback.comment;
        this.initialFeedbackSnapshot.rating = existingFeedback.rating;
      }
    }
  },
  computed: {
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
    }),
    anonymityFeedback() {
      const anonymityFeedback = this.tenantSettingConfig("anonymity_feedback");
      return anonymityFeedback
        ? anonymityFeedback["anonymity_feedback"]
        : "anonymous";
    },
    meetingFeedbacks() {
      return this.selectedMeeting.meeting_feedbacks;
    },
    feedback: {
      get() {
        const existingFeedback = this.meetingFeedbacks.find(
          (f) =>
            f.user_id === this.$auth.user.user_id &&
            f.topic_id === this.topic.Id
        );
        return (
          existingFeedback || {
            rating: 0,
            comment: "",
            user_id: this.$auth.user.user_id,
            id: createUUID(),
            feedback_type: "topic_feedback",
            topic_id: this.topic.Id,
            topic_name: this.topic.topicName,
            topic_category: this.topic.topicCategory,
            agenda_id: this.topic.agendaId,
            agenda_name: this.topic.agendaName,
            agenda_category: "",
            is_anonymous: this.anonymityFeedback === "anonymous",
          }
        );
      },
      set(updatedFeedback) {
        const newValue = [...this.meetingFeedbacks];
        const index = newValue.findIndex(
          (f) =>
            f.user_id === this.$auth.user.user_id &&
            f.topic_id === this.topic.Id
        );

        if (index !== -1) {
          newValue[index] = {
            ...updatedFeedback,
            is_anonymous: this.anonymityFeedback === "anonymous",
          };
        } else {
          newValue.push(updatedFeedback);
        }
        this.selectedMeeting.meeting_feedbacks = newValue;
        // this.$eventHub.$emit("onMeetingUpdate");
      },
    },
    feedbackRating: {
      get() {
        return this.feedback.rating;
      },
      set(value) {
        this.feedback = { ...this.feedback, rating: value };
      },
    },
    feedbackComment: {
      get() {
        return this.feedback.comment;
      },
      set(value) {
        this.feedback = { ...this.feedback, comment: value };
      },
    },
    isDirty() {
      return (
        this.feedbackRating !== this.initialFeedbackSnapshot.rating ||
        this.feedbackComment !== this.initialFeedbackSnapshot.comment
      );
    },
  },
  methods: {
    ...mapActions({
      addMeetingTopicFeedback: "meeting/addMeetingTopicFeedback",
    }),
    onSaveTopic,
    resetFeedback() {
      this.feedback = {
        ...this.feedback,
        rating: this.initialFeedbackSnapshot.rating,
        comment: this.initialFeedbackSnapshot.comment,
      };
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
  },
};

async function onSaveTopic() {
  const data = {
    rating: this.feedback.rating,
    comment: this.feedback.comment,
    id: this.feedback.id,
    feedback_type: this.feedback.feedback_type,
    topic_id: this.feedback.topic_id,
    agenda_id: this.feedback.agenda_id,
    is_anonymous: this.feedback.is_anonymous,
    meetingId: this.selectedMeeting.id,
  };
  await this.addMeetingTopicFeedback(data);
  this.initialFeedbackSnapshot.comment = this.feedback.comment;
  this.initialFeedbackSnapshot.rating = this.feedback.rating;
  this.showMessageSheet(this.$t("agenda.lblSaveFeedbackMsg"), "success");
}
</script>

<style scoped>
.v-expansion-panel-header {
  padding: 0px;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
}
</style>